<template>
  <div class="turn-root">
    <AppHeader />
    <div class="turn-content">
      <!-- Page Header -->
      <div class="turn-page-header">
        <div>
          <span class="turn-badge">🕐 Turnos</span>
          <h1 class="turn-title">Asignación de Turnos</h1>
          <p class="turn-subtitle">Generá y exportá los turnos de la procesión seleccionada</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="turn-actions">
        <button class="sys-btn sys-btn--primary" @click="generaTurnos" :disabled="loading">
          <span v-if="!loading">⚡ Generar Turnos</span>
          <span v-else class="btn-spinner"></span>
        </button>
        <button class="sys-btn sys-btn--green" @click="exportToExcel">
          📊 Exportar a Excel
        </button>
        <button class="sys-btn sys-btn--blue" @click="exportToPDF">
          📄 Exportar codos turnos
        </button>
      </div>

      <v-overlay :value="loading" color="var(--sys-bg)" opacity="0.9">
        <div class="turn-loading">
          <div class="turn-spinner"></div>
          <span>Procesando...</span>
        </div>
      </v-overlay>

      <!-- Table -->
      <div class="turn-table-wrap">
        <AppTable :Turnos="ListaTurnos" ref="tableComponent" />
      </div>

      <!-- Dialog sesión expirada -->
      <v-dialog v-model="showSessionExpiredDialog" max-width="400">
        <div class="sys-dialog">
          <div class="sys-dialog__header">
            <span class="sys-dialog__title">⏱️ Sesión expirada</span>
          </div>
          <p class="sys-dialog__msg">Tu sesión ha expirado. Por favor, iniciá sesión nuevamente.</p>
          <div class="sys-dialog__actions">
            <button class="sys-btn sys-btn--primary" @click="redirectToLogin">Iniciar sesión →</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import AppTable from "@/components/TableTurnosC.vue";
import axios from "axios";
import { utils as XLSXUtils, writeFile as writeExcel } from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "TurnosView",
  data() {
    return {
      showSessionExpiredDialog: false,
      ListaTurnos: [],
      loading: false,
      validToken: false,
    };
  },
  components: {
    AppHeader,
    AppTable,
  },
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.validateToken();
      await this.obtieneRegistros();
    },
    async exportToPDF() {
      const doc = new jsPDF({ orientation: "p", unit: "mm", format: [142, 210] });
      const stickerWidth = 64, stickerHeight = 32, marginLeft = 4, marginTop = 1;
      const columnSpacing = 6, rowSpacing = 3, columns = 2, rows = 6, lineHeight = 5;
      const maxChars = 25;
      let currentIndex = 0;
      this.loading = true;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      this.ListaTurnos.forEach((item) => {
        if (currentIndex >= columns * rows) { doc.addPage(); currentIndex = 0; }
        const col = currentIndex % columns;
        const row = Math.floor(currentIndex / columns);
        const x = marginLeft + col * (stickerWidth + columnSpacing);
        const y = marginTop + row * (stickerHeight + rowSpacing);
        const truncateText = (text) => text.length > maxChars ? text.substring(0, maxChars - 3) + "..." : text;
        const textLines = [
          `Nombre: ${truncateText(item.Nombre_Cargador)}`,
          `CUI: ${truncateText(item.Documento_Identificacion)}`,
          `Turno: ${truncateText(item.Numero_Turno)}`,
          `Brazo: ${truncateText(item.Numero_Brazo)}`,
          `Recibo No: ${truncateText(item.No_Recibo)}`,
          `Mesa: ${truncateText(item.Mesa)}`
        ];
        let textY = y + 5;
        textLines.forEach((text) => { doc.text(text, x, textY); textY += lineHeight; });
        currentIndex++;
      });
      doc.save("Stickers-Turnos.pdf");
      this.loading = false;
    },
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) { this.$cookies.remove(cookie); }
      this.$router.push("/sistema");
    },
    async generaTurnos() {
      await this.validateToken();
      this.loading = true;
      const apiUrl = "https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/turnos";
      const config = { headers: { Authorization: `Bearer ${this.$cookies.get("token")}` } };
      const proc = this.$cookies.get("ProcesionID");
      const bodyReq = { idProcesion: proc, usuarioResponsable: this.$cookies.get("username") };
      axios
        .post(apiUrl, bodyReq, config)
        .then(() => { this.obtieneRegistros(); this.loading = false; })
        .catch(() => { this.loading = false; });
    },
    validateToken() {
      const token = this.$cookies.get("token");
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      return axios.get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          this.$cookies.set("username", username, "1d", "", "", true, "Strict");
          this.validToken = true;
          this.loading = false;
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
          this.loading = false;
          this.clearAllCookies();
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) { this.$cookies.remove(cookie); }
    },
    async obtieneRegistros() {
      await this.validateToken();
      this.loading = true;
      const token = this.$cookies.get("token");
      const proc = this.$cookies.get("ProcesionID");
      const apiUrl = `https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/turnos/${proc}?usuarioResponsable=${this.$cookies.get("username")}`;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      return axios.get(apiUrl, config)
        .then((response) => { this.ListaTurnos = response.data.records; this.loading = false; })
        .catch(() => { this.loading = false; });
    },
    exportToExcel() {
      const wb = XLSXUtils.book_new();
      const ws = XLSXUtils.json_to_sheet(this.ListaTurnos);
      XLSXUtils.book_append_sheet(wb, ws, "Turnos");
      writeExcel(wb, "Turnos.xlsx");
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.turn-root {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: var(--sys-bg);
}

.turn-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 32px 60px;
}

/* ── Loading ── */
.turn-loading {
  display: flex; flex-direction: column; align-items: center; gap: 14px;
  color: var(--sys-text-secondary); font-size: 0.9rem;
}
.turn-spinner {
  width: 36px; height: 36px;
  border: 3px solid rgba(123,47,247,0.3);
  border-top-color: #7b2ff7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Page Header ── */
.turn-page-header { margin-bottom: 32px; }
.turn-badge {
  display: inline-block;
  background: rgba(123,47,247,0.15);
  border: 1px solid rgba(123,47,247,0.35);
  color: #c4a0ff;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.03em;
}
.turn-title {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 6px;
}
.turn-subtitle {
  color: var(--sys-text-secondary);
  font-size: 0.95rem;
  margin: 0;
}

/* ── Action Buttons ── */
.turn-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

/* ── Table ── */
.turn-table-wrap {
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 8px;
  backdrop-filter: blur(12px);
  overflow: hidden;
}

::v-deep .v-data-table { background: transparent !important; }
::v-deep .v-data-table .v-data-table__wrapper table { background: transparent !important; }
[data-theme="dark"] ::v-deep .v-data-table thead tr th {
  background: rgba(123,47,247,0.12) !important;
  color: rgba(255,255,255,0.7) !important;
}
::v-deep .v-data-table thead tr th {
  background: var(--sys-table-header) !important;
  color: var(--sys-text-secondary) !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-table tbody tr { background: transparent !important; transition: background 0.2s !important; }
::v-deep .v-data-table tbody tr:hover { background: var(--sys-table-row-hover) !important; }
::v-deep .v-data-table tbody tr td {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-footer {
  background: transparent !important;
  border-top: 1px solid var(--sys-card-border) !important;
  color: var(--sys-text-secondary) !important;
}
::v-deep .v-data-footer .v-select__selection {
  color: var(--sys-text-primary) !important;
}

/* ── Buttons ── */
.sys-btn {
  padding: 11px 22px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
}
.sys-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.35);
}
.sys-btn--primary:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(123,47,247,0.5); }
.sys-btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }

.sys-btn--green {
  background: rgba(74,222,128,0.15);
  color: #86efac;
  border: 1px solid rgba(74,222,128,0.3);
}
.sys-btn--green:hover { background: rgba(74,222,128,0.25); }

.sys-btn--blue {
  background: rgba(96,165,250,0.15);
  color: #93c5fd;
  border: 1px solid rgba(96,165,250,0.3);
}
.sys-btn--blue:hover { background: rgba(96,165,250,0.25); }

.btn-spinner {
  width: 18px; height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

/* ── Dialog ── */
.sys-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 28px 24px;
  font-family: 'Inter', sans-serif;
}
.sys-dialog__header { margin-bottom: 12px; }
.sys-dialog__title { font-size: 1.2rem; font-weight: 800; color: var(--sys-text-primary); display: block; }
.sys-dialog__msg { color: var(--sys-text-secondary); font-size: 0.92rem; margin: 0 0 24px; }
.sys-dialog__actions { display: flex; justify-content: flex-end; }

@media (max-width: 768px) {
  .turn-content { padding: 80px 16px 40px; }
}
</style>
